import type { IFilterPanelBaseFilterDeps, IFilterPanelBaseFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";

import type { IAppsAdSellersFilterItem } from "../../types/commonFiltersDto";
import type { IAppsAdsSellersFilterDescriptionDto } from "../../types/descriptionDto";

export default class FindAppsAdsSellersFilter
    extends FilterPanelBaseFilter<IAppsAdSellersFilterItem[], IAppsAdsSellersFilterDescriptionDto>
    implements IFilterPanelBaseFilterModel<IAppsAdSellersFilterItem[], IAppsAdsSellersFilterDescriptionDto>
{
    constructor(deps: IFilterPanelBaseFilterDeps<IAppsAdSellersFilterItem[], IAppsAdsSellersFilterDescriptionDto>) {
        super(deps);
    }

    isFilterDirty(currentValue: IAppsAdSellersFilterItem[] | undefined): boolean {
        return Boolean(currentValue && currentValue.length > 0);
    }
}
